// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { ChatWithUserMenu } from './chat-with-user-menu'

const COMPONENT_ID = 'chatWithUserMenu'

interface Prop {
  userId: string
}

export const showChatWithUserMenu = (props: Prop, preventBackClick = false) =>
  addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: ChatWithUserMenu },
}
